// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Sk5q","row":"Node_row__2Fw5M","label":"Node_label__3LOPa","footer":"Node_footer__OWKtG"};